import { SET_EXPORT_PROCESSING } from "../actions/ExportActions";

const initialState = {
    processing: false
};

const ExportReducer = function (state = initialState, action) {
    switch (action.type) {
        case SET_EXPORT_PROCESSING: {
            return {
                ...state,
                processing: action.payload
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default ExportReducer;